/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Refresh_Subscription_StatusInputs */

const en_common_refresh_subscription_status = /** @type {(inputs: Common_Refresh_Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh Subscription Status`)
};

const es_common_refresh_subscription_status = /** @type {(inputs: Common_Refresh_Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar estado de suscripción`)
};

/**
* | output |
* | --- |
* | "Refresh Subscription Status" |
*
* @param {Common_Refresh_Subscription_StatusInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_refresh_subscription_status = /** @type {((inputs?: Common_Refresh_Subscription_StatusInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Refresh_Subscription_StatusInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_refresh_subscription_status(inputs)
	return en_common_refresh_subscription_status(inputs)
});